<template>
    <div>
    <v-card :elevation="0" class="v-sheet theme--light br-0">
        <v-card-title>
            <v-row class="col-md-12">
                <v-col cols="12" sm="12" md="6">
                    Administración de Instituciones
                </v-col>

                <v-col cols="12" sm="12" md="6">
                    <v-btn
                        color=""
                        dark
                        class="mb-2 float-right bg-light-blue"
                        
                        @click="modalNueva"
                    >
                        Crear nueva
                    </v-btn>
                </v-col> 
        
            </v-row>
            <v-row class="col-md-12 m-0 p-0">
                <v-divider></v-divider>
            </v-row>
            
            <v-row class="col-md-12 d-none">
                    
                <v-spacer></v-spacer>
                <v-col cols="12" sm="12" md="6">
                    
                    <v-text-field
                    v-model="searchItem"
                    append-icon="search"
                    label="Buscar"
                    outlined
                    autocomplete="off"
                    dense
                    hide-details
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card-title>
                     
        <v-card-text>

            <v-row class="d-flex align-end flex-column mb-4">
                    
                <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1 align-end">
                    <v-text-field
                        append-icon="mdi-magnify"
                        outlined
                        dense
                        v-model="filtroBusqueda"
                        label="Buscar"
                    ></v-text-field>
                </v-col>
            </v-row>


            <v-data-table
                :headers="headers"
                :items="items"
                item-key="Id"
                class="elevation-0"
                :loading="tableLoading"
                no-data-text="No hay datos para mostrar"
                :search="filtroBusqueda"
                :items-per-page="10"
                dense
                :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-page-first',
                    lastIcon: 'mdi-page-last',
                    prevIcon: 'mdi-chevron-left',
                    nextIcon: 'mdi-chevron-right',
                    'items-per-page-text':'Registros por página',
                    pageText: '{0}-{1} de {2}' 
                }"
                >
                <template v-slot:item="{ item }">
                     <tr v-if="item.estadosId === 1 || true">
                        <td>{{ item.id }}</td>
                        <td>{{ item.nombreInstitucion }}</td>
                        <td>{{ item.siglas }}</td>   
                        <td>{{ item.correoUsuario}}</td>
                        <td>{{ item.telefonoUsuario}}</td>
                        <td>
                            <v-chip
                                    class="ma-2"
                                    :color="item.estadosId === 1 ? 'teal' : item.estadosId ===2 ? 'red' : item.estadosId ===3 ? 'blue' : 'red' "
                                    text-color="white"
                                    small
                                >
                                    {{item.estado}}
                            </v-chip>
                        </td>
                        <td>
                            <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                <v-icon left>mdi-pencil</v-icon> Actualizar
                            </v-btn>

                            <v-btn class="ma-2" small tile outlined color="indigo" @click="mostrarModalResetPass(item.nombreInstitucion, item.id, item.correoUsuario)">
                                <v-icon left>mdi-lock-reset</v-icon> Restablecer contrase&ntilde;a
                            </v-btn>
                        </td>
                    </tr>
                </template>

            </v-data-table>
        </v-card-text>

        
    </v-card>

    <!-- Dialog para registro actualizacion -->
    <v-dialog
        v-model="dialog"
        max-width="900px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{dialogTitulo}}
                <v-spacer></v-spacer>
                <v-btn
                    icon

                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                    ref="form"
                    v-model="validForm"
                    v-on:submit.prevent="registrarItem"
                    >
                <v-card-text class="p-10">                   
                    <v-row>
                        <v-col cols="12" md="8" sm="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosInstitucion.nombreInstitucion"
                                label="Nombre de la institución"
                                :rules="[
                                    required(
                                        'Nombre de la institución'
                                    ),
                                    minLength('Nombre de la institución', 5),
                                    alphaRule('Nombre de la institución')

                                ]"
                                pattern="[a-zA-Z0-9]+"
                                maxlength="100"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="4" sm="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosInstitucion.siglas"
                                label="Siglas"
                                :rules="[
                                    required('Siglas'),
                                    minLength('Siglas', 3),
                                    alphaRule('Siglas')
                                ]"
                                maxlength="20"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>

                        
                    <v-row>
                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosInstitucion.nombreUsuario"
                                label="Nombre del usuario"
                                :rules="[
                                    required('Nombre del usuario'),
                                    minLength('Nombre del usuario', 5),
                                    alphaRule('Nombre del usuario')
                                ]"
                                maxlength="50"
                                required
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                                <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosInstitucion.correoUsuario"
                                label="Correo máster"
                                :rules="[
                                    validEmail(
                                        'correo'
                                    )
                                ]"
                                required
                                maxlength="200"
                            ></v-text-field>
                        </v-col>                        
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosInstitucion.telefono"
                                label="Teléfono"
                                :rules="[
                                    required('Teléfono'),
                                    minLength('Teléfono', 8),
                                ]"
                                maxlength="20"
                                v-mask="'####################'"
                                required
                            ></v-text-field>
                        </v-col>

                    </v-row>

                    
                    <v-row>
                        <v-col cols="12" md="12" sm="12" class="pt-1 pb-1">
                            <label class="grey--text body-2">Estado</label>
                            <v-switch
                            v-model="switchItemEstado"
                            inset
                            :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pr-8 pl-8">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey lighten-5"
                        elevation="0"
                        :disabled="btnRegistroLoading"
                        class="mb-2 float-right grey lighten-5"
                        @click="dialog = false; resetForm()"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="mb-2 float-right"
                        
                        :elevation="0"
                        :loading="btnRegistroLoading"
                        :disabled="!validForm"
                        type="submit"
                    >
                        {{btnRegistroText}}
                    </v-btn>
                    <!-- :loading="btnLoading"
                        :disabled="!validForm"-->
                        
                </v-card-actions>
                   
            </v-form>
            <div style="flex: 1 1 auto;"></div>
        </v-card>
    </v-dialog>
    <!--Fin:: Dialog para registro/actualizacion-->



    <!-- Inicio:: Dialog para para restablecer contraseña-->
    <v-dialog
        v-model="dialogResetPass"
        max-width="600px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                Restablecer contrase&ntilde;a
                
                <v-spacer></v-spacer>
                <v-btn
                    icon

                    @click="dialogResetPass = false"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                    ref="resetPassForm"
                    v-on:submit.prevent="restablecerContrasenia"
                    >
            <v-card-text>
                <v-container>
                    <h4>Está seguro de restablecer la contrase&ntilde;a para {{nombreInstitucion}}?</h4>
                </v-container>
            </v-card-text>
            <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            color="grey lighten-5"
                            elevation="0"
                            :disabled="btnResetPassLoading"
                            class="mb-2 float-right grey lighten-5"
                            @click="dialogResetPass = false"
                        >
                            Cancelar
                        </v-btn>
                        <!--:disabled="!validDocForm" type="submit"-->
                        <v-btn
                            color="primary"
                            class="mb-2 float-right"
                            type="submit"
                            :elevation="0"
                            :loading="btnResetPassLoading"                           
                        >
                            Restablecer
                        </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    

    <!-- Fin:: Dialog para restablecer contraseña-->
   


    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import moment from "moment";
import validations from "@/core/untils/validations.js";
//import axios from "axios";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { RESTABLECER_PASS_USUARIO } from "@/core/services/store/usuarios/usuario.module";
import { OBTENER_INSTITUCIONES, OBTENER_INSTITUCION, REGISTAR_INSTITUCION, ACTUALIZAR_INSTITUCION } from "@/core/services/store/institucion.module";

import DialogLoader from "@/view/content/DialogLoader";

import SnackAlert from '@/view/content/SnackAlert.vue';
//import SubHeader from "@/view/components/subheader/SubHeader";

//import RegistroContacto from '@/view/components/contactos/RegistroContacto.vue';


moment.locale('es');

export default {
    name: "AdminInstituciones",
    components: {
        "dialog-loader": DialogLoader,
        SnackAlert,
        //SubHeader,
       // RegistroContacto
    },
    data(){
        return{
            itemName: 'Institución',
            itemsName: 'Instituciones',
            tableLoading:false,
            filtroBusqueda:'',
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo información...',
            dialogResetPass:false,
            btnResetPassLoading:false,
            isAsesorLoading:false,
            dialog: false,
            activeTab:'empresa',
            dialogDoc:false,
            dialogTitulo: `Registrar ${this.itemName}`,
            dialogConfirmarEstado: false,
            btnLoading:false,
            btnCancelDisabled: false,
            btnRegistroText: `Registrar ${this.itemName}`,
            btnRegistroLoading: false,
            btnRegistroDocLoading:false,
            btnRegistroContactoLoading:false,
            btnEnvioCompliantLoading:false,
            validForm: false,
            accion:1, //1 registrar, 2 actualizar
            ...validations,
            items: [],
            searchItem:'',
            showPass: false,
            nombreInstitucion:'',
            idInstitucion: 0,
            datosInstitucion: {
                //fechaActualizacion: null,
                //fechaCreacion: '20-10-2021',
                id: 0,
                nombreInstitucion: '',
                //usuarioActualizacion: null,
                usuarioCreacion: 'admin',
                usuarios: null,
                contraseniaUsuario:'',
                correoUsuario:'',
                siglas: '',
                estadosId: 1,
                telefono: '',
                nombreUsuario:'',
                usuariosId:0,

            },
            datosPass:{
                idUsuario: 0,
                correoUsuario: '',
                usuarioActualizacion: ''
             },
            switchItemEstado: true,
            dateMin: moment('1920-01-01').format('MM-DD-YYYY'),
            rangoCantidadTrabajadores:[{id: 'micro de 1 a 10', rango: 'micro de 1 a 10'},{id: 'pequeña de 11 a 80', rango: 'pequeña de 11 a 80'},{id: 'mediana de 81 a 200', rango: 'mediana de 81 a 200'},{id: 'grande más 200', rango: 'grande más de 200'}],
            activePicker: null,
            //Para cambio de estado
            itemTipo: 0,
            estadoNuevo: 0,


            
        }
    },
    methods:{
        async obtenerItems(){
            this.items=[];
            this.tableLoading=true;

            this.$store
            .dispatch(OBTENER_INSTITUCIONES)
            .then(() => {
                this.items = this.$store.state.institucion.instituciones;
                //console.log(this.items)
                //console.log(this.items)
                this.tableLoading=false;
            })
            .catch(() => {
                this.tableLoading=false;
            });   
        },

        //!Mostrar el modal para el registro de un nuevo item
        async modalNueva() {
            //console.log('obteniendod datos')
            this.dialogTitulo=`Registrar ${this.itemName}`;
            this.btnRegistroText=`Registrar ${this.itemName}`;
            this.accion =1;
            this.activeTab = 'empresa';
            //this.subTipoSocios=[];
            this.municipios=[];
            this.dialog=true;
        },

        //!Restablecer campos del formulario, 
        resetForm(){
            //Hacer referencia al form con $refs
            //this.$refs.form.reset();
            this.datosInstitucion= {
                //fechaActualizacion: null,
                //fechaCreacion: '20-10-2021',
                id: 0,
                nombreInstitucion: '',
                //usuarioActualizacion: null,
                usuarioCreacion: 'admin',
                usuarios: null,
                contraseniaUsuario:'',
                correoUsuario:'',
                siglas: '',
                nombreUsuario:'',
                estadosId: 1,
                telefono:'',
                usuariosId:0

            };
            this.switchItemEstado=true;
            this.accion = 1;
        },

        //!Registrar 1/Actualizar 2 un item
        async registrarItem(){
            //this.dialogLoaderVisible = true;
            //this.dialogLoaderText = 'Guardando información...';
            this.btnRegistroLoading=true;

            //!Asignar el estado a datos empresa segun lo seleccionado en el swithc del formulario
            this.switchItemEstado
                ? (this.datosInstitucion.estadosId = 1)
                : (this.datosInstitucion.estadosId = 2);

            //?Si accion es 1 se realiza el registro
            if(this.accion===1){        
                this.$store
                    .dispatch(REGISTAR_INSTITUCION, this.datosInstitucion)
                    .then(res => {
                        
                       
                        this.btnLoading=false;
                        //this.dialogLoaderVisible = false;
                        
                        
                        if(res.status===200){
                            
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.obtenerItems();
                            this.dialog=false;
                            this.resetForm();
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                        
                    })
                    .catch(() => {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error durante el registro.`);
                    });
            } 
            //?Si accion es 2 se realiza la actualizacion
            else {
                this.$store
                    .dispatch(ACTUALIZAR_INSTITUCION, {datosInstitucion: this.datosInstitucion, id: this.datosInstitucion.id} )
                    .then(res => {
                       
                        this.btnLoading=false;
                        this.dialogLoaderVisible = false;
                        this.btnRegistroLoading=false;
                        
                        if(res.status===200){
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.dialog=false;
                            this.obtenerItems();
                            this.resetForm();
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        
                        //console.log(this.datosInstitucion + res)
                    })
                    .catch(() => {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error durante el registro.`);
                    });
            }
            
            
        },

        //!Obtener datos de un item especifico
        obtenerDatosItem(Id){
            this.empresaId = Id;
            this.dialogLoaderVisible = true;
            this.dialogLoaderText = 'Obteniendo información...';
            this.dialogTitulo=`Actualizar ${this.itemName}`;
            this.btnRegistroText = `Actualizar ${this.itemName}`;
            //!Pre seleccionar el tab de datos de la empresa
            this.activeTab = 'empresa';
            this.$store
            .dispatch(OBTENER_INSTITUCION, Id)
            .then(res => {

                //console.log(res);
                if(res.status===200){
                    this.datosInstitucion =  this.$store.state.institucion.institucion;  
                    this.datosInstitucion.contraseniaUsuario = "Segeplan@2021"
                    this.datosInstitucion.estadosId===1 ? this.switchItemEstado=true : this.switchItemEstado = false;
                    this.accion = 2; 
                    this.dialog = true;
                } else {
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema.`);
                }
                this.dialogLoaderVisible = false;
            })
            .catch(() => {
                 this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema.`);
                this.dialogLoaderVisible = false;
            });

            
            
        },
       
       /**
        * Modal de confirmacion de cambio de contraseña
        */
       mostrarModalResetPass(nombreInstitucion, id, correoUsuario){
           this.dialogResetPass=true;
           this.nombreInstitucion = nombreInstitucion;
           this.idInstitucion = id;
           this.datosPass.idUsuario = id;
           this.datosPass.correoUsuario = correoUsuario;
           this.datosPass.usuarioActualizacion = id.toString();
       },

       /**
        * Restablecer la contraseña del usuario master institucion
        */
       restablecerContrasenia(){
           this.btnResetPassLoading = true;
           this.$store
           .dispatch(RESTABLECER_PASS_USUARIO, this.datosPass)
           .then(res => {
               if(res.status==200){
                   this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                   this.dialogResetPass = false;
               } else {
                   this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error durante la actualización.`);
               }
               this.btnResetPassLoading = false;
            })
           .catch(err => {
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema. REF: ${err}`);
                this.btnResetPassLoading = false;
            });


       }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Instituciones" }
        ]);
    },
    created(){
        this.obtenerItems();
    },
    computed: {
        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Nombre Institución",
                    value: "nombreInstitucion"
                },
                {
                    text: "Siglas",
                    value: "siglas"
                },
                {
                    text: "Usuario Máster",
                    value: "correoUsuario"
                },
                 {
                    text: "Teléfono",
                    value: "telefonoUsuario"
                },
                {
                    text: "Estado",
                    value: "estado"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        },

        documentosHeaders(){
            return [
                 {
                    text: "Id",
                    align: "start",
                    sortable: false,
                    value: "id"
                },
                 {
                    text: "Tipo documento",
                    align: "start",
                    sortable: true,
                    value: "nombre"
                },
                 {
                    text: "Acciones",
                    align: "start",
                    sortable: false,
                    value: "acciones"
                },

            ]
        },

        contactoHeaders(){
            return [
                {
                    text: 'Nombre del contacto',
                    align: 'start',
                    sortable: true,
                    value: 'nombre_Completo',
                },
                { text: 'Correo', value: 'email' },
                { text: 'Teléfono', value: 'telefono' },
            ]
        },

        contactoProps() {
        return {
            empresaId: this.datosInstitucion.id
        };
        },

       

    }
}
</script>
